import AccountSwitcher from './account-switcher';

export default AccountSwitcher;
